import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
// components
// middlewares
import MemoInMiddleware from "../../../middleware/modules/accounting/memo-in";
import PrintMemoIn from "../../../components/utilities/print/default/memo-in";

const mapStateToProps = ({ auth, memoin }) => ({
  isAuthenticated: auth.isAuthenticated,
  isProcessing: auth.isProcessing,
  isRegistered: auth.isRegistered,
  isError: auth.isError,
  errorMessage: auth.errorMessage,
  dataPrint: memoin.printMemoIn,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getPrint: (id) => MemoInMiddleware.getPrint(id),
    },
    dispatch
  );
};

class MemoInContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  static propTypes = {
    isAuthenticated: PropTypes.bool,
    isProcessing: PropTypes.bool,
    isRegistered: PropTypes.bool,
    isError: PropTypes.bool,
    errorMessage: PropTypes.any,
  };

  static defaultProps = {
    isAuthenticated: false,
    isProcessing: false,
    isRegistered: false,
    isError: false,
    errorMessage: [],
  };

  UNSAFE_componentWillMount() {
    this.props.getPrint(this.props.id);
  }

  render() {
    const {
      isAuthenticated,
      isProcessing,
      isRegistered,
      isError,
      errorMessage,
    } = this.props;
    return <PrintMemoIn {...this.props} />;
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MemoInContainer);
